import { Box, Button, Card, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import {
  addOneItem,
  getDashboardClasses,
  removeOneItem,
} from "../../Api/DashboardApi";
import GlobalCard from "../../../../components/GlobalCardComponent";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { useDispatch, useSelector } from "react-redux";
import { TOGGLE_WISHLIST } from "../../../../../actions";
import CustomSnackbar from "../../../../../newTestPreo/components/snackbar/Snackbar";
import AnimatedSnackbar from "../../../../components/snackbars/AnimatedSnackbar";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";
import { useSnackbar } from "../../../../components/snackbars/SnackbarContext";

export default function RunningClassesDashboard() {
  const scrollRef = useRef(null);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState(null);
  const [hasFetchedNextPage, setHasFetchedNextPage] = useState(false);
  const userId = localStorage.getItem("userId");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [bookmarked, setBookmarked] = useState({}); // object to track multiple items
  const wishlistItems = useSelector((state) => state.wishlist.items);

  const { showSnackbar } = useSnackbar();



  // Scroll functions
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const FetchClassData = async (page = 1) => {
    
    try {
      const response = await getDashboardClasses({
        sp_user_id: parseInt(userId),
        limit: 6,
        page,
      });

      setCardData((prev) =>
        page === 1 ? response?.data : [...prev, ...response.data]
      );
      setPagination(response.pagination);
      setLoading(false);
      setHasFetchedNextPage(false); // ✅ Reset after data fetch
    } catch (error) {
      console.error("Error fetching courses:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchClassData();
  }, []);

  // Scroll End Detection for Auto Pagination
  useEffect(() => {
    const handleScroll = () => {
      const container = scrollRef.current;
      if (!container || !pagination) return;

      const isAtEnd =
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth - 4;

      if (
        isAtEnd &&
        pagination.current_page < pagination.total_page &&
        !hasFetchedNextPage
      ) {
        setHasFetchedNextPage(true);
        FetchClassData(pagination.current_page + 1);
      }
    };

    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [pagination, hasFetchedNextPage]);

  const handleVieClasses = () => {
    const url = `/test-prep/classes`;
    window.open(url, "_blank");
  };

  // ✅ Toggle function
  const handleToggleData = async (data) => {
    try {
      const payload = {
        service_id: 1,
        class_id: data?.id,
        user_id: parseInt(userId),
      };

      const isAlreadyBookmarked = wishlistItems.some((w) => w.id === data.id);

      // ✅ choose API dynamically
      const apiCall = isAlreadyBookmarked
        ? removeOneItem({ ...payload, is_adding: false })
        : addOneItem({ ...payload, is_adding: true });

      const response = await apiCall;

      // ✅ response handling in one place
      if (response.status === 200) {
        showSnackbar(response.message, "success");
        // ✅ update redux

        dispatch({
          type: TOGGLE_WISHLIST,
          payload: data, // 👈 full object from API
        });

        // ✅ update UI state instantly
        setBookmarked((prev) => ({
          ...prev,
          [data.id]: !isAlreadyBookmarked,
        }));
      } else if ([400, 401, 500].includes(response.status)) {
        showSnackbar(response.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Toggle error:", error);
      showSnackbar("An error occurred while updating wishlist", "error");
    }
  };

  // select default bookmark items
  useEffect(() => {
    if (cardData?.length) {
      const bookmarkedMap = cardData.reduce((acc, item) => {
        acc[item.id] = wishlistItems.some((w) => w.id === item.id);
        return acc;
      }, {});
      setBookmarked(bookmarkedMap);
    }
  }, [wishlistItems, cardData]);

  const handleNavigateToClass = (classData) => {
    navigate("/test-prep/packages", {
      state: { classData },
    });
  };

  return (
    <>
      <Grid container mt={0}>
        <Grid item xs={12}>
          <CustomCardWithBorder boxShadow={true} padding="10px">
            <Grid container>
              <Grid item xs={12} px={1}>
                <Grid
                  container
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    fontSize="20px"
                    color="#161719"
                    sx={{ fontWeight: 600, fontFamily: "Inter" }}
                  >
                    Ongoing Batches
                  </Typography>

                  <Typography
                    fontSize="14px"
                    color="#572575"
                    onClick={handleVieClasses}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "Inter",
                      cursor: "pointer",
                    }}
                  >
                    See All
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={12} mt={1}>
                <Box height="100%">
                  {loading ? (
                    <Loader height="20vh" text="Loading Classes..." />
                  ) : (
                    <Grid
                      container
                      justifyContent="center"
                      sx={{
                        borderRadius: "20px",
                        position: "relative",
                        width: "100%",
                        maxWidth: "100%",
                      }}
                    >
                      {/* Left Arrow */}
                      <IconButton
                        onClick={scrollLeft}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: -5,
                          width: "20px",
                          height: "20px",
                          transform: "translateY(-50%)",
                          bgcolor: "#fff",
                          boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                          border: "1px solid #572575",
                          "&:hover": { bgcolor: "#f2f2f2" },
                        }}
                      >
                        <ArrowBackIosNewIcon
                          style={{ color: "#572575", width: "10px" }}
                        />
                      </IconButton>

                      {/* Right Arrow */}
                      <IconButton
                        onClick={scrollRight}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          right: -8,
                          width: "20px",
                          height: "20px",
                          transform: "translateY(-50%)",
                          bgcolor: "#fff",
                          border: "1px solid #572575",
                          boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                          opacity:
                            !pagination ||
                            pagination.current_page === pagination.total_page
                              ? 0.4
                              : 1,
                          "&:hover": { bgcolor: "#f2f2f2" },
                        }}
                      >
                        <ArrowForwardIosIcon
                          fontSize="small"
                          style={{ color: "#572575", width: "10px" }}
                        />
                      </IconButton>

                      {/* Scrollable Card Row */}
                      <Box
                        ref={scrollRef}
                        sx={{
                          display: "flex",
                          gap: 3,
                          overflowX: "auto",
                          scrollBehavior: "smooth",
                          "&::-webkit-scrollbar": { display: "none" },
                          maxWidth: {
                            xs: "300px",
                            sm: "500px",
                            md: "960px",
                            lg: "1024px",
                            xl: "1200px",
                          },
                          padding: "5px",
                        }}
                      >
                        {cardData?.map((data, index) => (
                          <Box
                            key={data?.id || index}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              borderRadius: "12px",
                              border: "1px solid #D0D0D0",
                              width: {
                                xs: "300px",
                                sm: "500px",
                                md: "200px",
                                lg: "230px",
                                xl: "360px",
                              },
                              height: "100%",
                              flexShrink: 0,

                              backgroundColor: "white",
                              padding: 1,
                            }}
                          >
                            <Box>
                              <Grid container spacing={1}>
                                <Grid item xs={12} position="relative">
                                  <Box
                                    right={2}
                                    top={6}
                                    style={{ zIndex: 3, position: "absolute" }}
                                  >
                                    <IconButton
                                      onClick={() => handleToggleData(data)}
                                      sx={{
                                        width: 25,
                                        height: 25,
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        backgroundColor:
                                          "rgba(255, 255, 255, 0.3)", // semi-transparent white
                                        borderRadius: "50%",
                                        boxShadow:
                                          "0px 2px 6px rgba(0, 0, 0, 0.1)",
                                        backdropFilter: "blur(4px)", // optional: glass effect
                                        zIndex: 2,
                                        "&:hover": {
                                          backgroundColor:
                                            "rgba(255, 255, 255, 0.4)",
                                        },
                                      }}
                                    >
                                      {bookmarked[data?.id] ? (
                                        <FavoriteIcon
                                          style={{
                                            color: "#572575",
                                            fontSize: "1rem",
                                          }}
                                        />
                                      ) : (
                                        <FavoriteBorderIcon
                                          style={{
                                            color: "#572575",
                                            fontSize: "1rem",
                                          }}
                                        />
                                      )}
                                    </IconButton>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: "100%",
                                      height: "100%",

                                      overflow: "hidden",
                                      zIndex: 1,
                                    }}
                                  >
                                    <img
                                      src={data?.image_path?.image_src}
                                      alt="IELTS Coaching"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                      }}
                                    />
                                  </Box>
                                </Grid>

                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xs={6}>
                                      <Typography
                                        fontSize="16px"
                                        color="#000000"
                                        fontFamily="Inter"
                                        fontWeight={600}
                                      >
                                        {data?.test_type_id?.name}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={6}
                                      container
                                      alignItems="center"
                                      justifyContent="end"
                                      gap={1}
                                    >
                                      <Box
                                        sx={{
                                          background:data?.mode_of_delivery==="offline"? "#FFF5DF" :"#96FF6666",
                                          py: "5px",
                                          px: "7px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                          borderRadius: "10px",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: "8px",
                                            height: "8px",
                                            backgroundColor:data?.mode_of_delivery==="offline" ?"#A28000" :"#32860B",
                                            borderRadius: "50%",
                                          }}
                                        />
                                        <Typography
                                          fontSize="12px"
                                          color={data?.mode_of_delivery==="offline" ?"#6E5906" : "#32860B"} 
                                          fontFamily="Inter"
                                          fontWeight={400}
                                        >
                                          {data?.mode_of_delivery
                                            ? data.mode_of_delivery
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.mode_of_delivery.slice(1)
                                            : ""}
                                        </Typography>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="start">
                                  <Typography
                                    fontSize="16px"
                                    color="#000000"
                                    fontFamily="Inter"
                                    fontWeight={500}
                                  >
                                    {data?.blog_name}
                                  </Typography>
                                </Grid>

                                {/* Slot Time */}
                                <Grid item xs={12} textAlign="start">
                                  <Box display="flex" alignItems="center">
                                    <Box height={10.5} width={11.67} mr={0.5}>
                                      <img src="/newdashboard/Enroll/mingcute_time-line.png" />
                                    </Box>

                                    <Typography
                                      sx={{
                                        color: "#161719",
                                        fontSize: 11,
                                        fontWeight: 400,
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      {data?.start_time} - {data?.end_time}
                                    </Typography>
                                  </Box>
                                </Grid>

                                {/* Location (only for offline) */}
                                <Grid item xs={12} textAlign="start">
                                  {data?.mode_of_delivery === "offline" && (
                                    <Box display="flex" alignItems="center">
                                      <Box height={10.5} width={11.67} mr={0.5}>
                                        <img src="/newdashboard/Enroll/mingcute_location-3-line.png" />
                                      </Box>

                                      <Typography
                                        sx={{
                                          color: "#161719",
                                          fontSize: 11,
                                          fontWeight: 400,
                                          fontFamily: "Inter",
                                        }}
                                      >
                                        {data?.branch_id?.branch_name}
                                      </Typography>
                                    </Box>
                                  )}
                                </Grid>

                                {/* days */}

                                <Grid item xs={12} textAlign="start">
                                  <Box display="flex" alignItems="center">
                                    <Box height={10.5} width={11.67} mr={0.5}>
                                      <img src="/newdashboard/Enroll/Frame (4).png" />
                                    </Box>

                                    <Typography
                                      sx={{
                                        color: "#161719",
                                        fontSize: 11,
                                        fontWeight: 400,
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      {data?.day?.map((day) => day).join(", ")}
                                    </Typography>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>

                            {/* Buttons */}
                            <Box
                              mt="auto"
                              textAlign="center"
                              pt={2}
                              display="flex"
                              flexDirection="column"
                              gap={1}
                              pb={1}
                            >
                              {/* <Button
                          variant="contained"
                          style={{
                            background: "#9D03851A",
                            color: "#9D0385",
                            fontWeight: "400",
                            borderRadius: "24px",
                            fontSize: "12px",
                            paddingLeft: 20,
                            paddingRight: 20,
                            fontFamily: "Inter",
                            height: "24px",
                            width: "100%",
                          }}
                        >
                          Book Demo
                        </Button> */}
                              <Button
                                variant="contained"
                                onClick={() => handleNavigateToClass(data)}
                                endIcon={
                                  <img
                                    src="/newdashboard/Enroll/Vector (3).png"
                                    style={{ width: 12 }}
                                  />
                                }
                                style={{
                                  background: "#572575",
                                  fontWeight: 700,
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                  fontFamily: "Inter",
                                  height: "27px",
                                  width: "100%",
                                }}
                              >
                                Enroll Now
                              </Button>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Grid>
                  )}
                </Box>
              </Grid>
            </Grid>{" "}
          </CustomCardWithBorder>
        </Grid>
      </Grid>
    
    </>
  );
}
